const EXTERNAL_LINK_MENUITEMS = {
  Geotab: 'https://my.geotab.com'
};

export {
  EXTERNAL_LINK_MENUITEMS
};
